import { Icon } from "./Icon.tsx";

/** "Streets" tab icon — a road receding into the distance with a dashed
 * center line. */
export function StreetIcon() {
  return (
    <Icon>
      <path d="M8 3 5 21" />
      <path d="M16 3l3 18" />
      <path d="M12 4v3M12 10.5v3M12 17v3" />
    </Icon>
  );
}
